export function setFormDisabled($j, $form, disabled, opts = {}) {
  const keepEnabled = opts.keepEnabled || []

  const $inputs = $form.find("input, select, textarea, button").filter(function () {
    const $el = $j(this)
    const type = ($el.attr("type") || "").toLowerCase()
    if (type === "hidden") return false
    if ($el.is("[data-skip-disable='true']")) return false
    return true
  })

  $inputs.prop("disabled", disabled)

  // re-habilita exceções (ex: o próprio CPF)
  keepEnabled.forEach(($el) => {
    try { $el.prop("disabled", false) } catch (_e) { }
  })
}
